var VehicleType;
(function (VehicleType) {
    VehicleType["PASSENGER"] = "Passenger";
    VehicleType["MOTORCYCLE"] = "Motorcycle";
    VehicleType["TRUCK"] = "Truck";
    VehicleType["COMMERCIAL"] = "Commercial";
    VehicleType["TRAILER"] = "Trailer";
    VehicleType["MOPED"] = "Moped";
    VehicleType["VESSEL"] = "Vessel";
    VehicleType["LOW_SPEED"] = "LowSpeed";
    VehicleType["MOTORSCOOTER"] = "Motorscooter";
    VehicleType["DUAL_SPORT"] = "DualSport";
    // off-road
    VehicleType["ATV"] = "ATV";
    VehicleType["ORV"] = "ORV";
    VehicleType["NON_TITLED_VEHICLE"] = "NonTitledVehicle";
    VehicleType["OHV"] = "OHV";
})(VehicleType || (VehicleType = {}));
const VehicleTypeDescriptions = {
    [VehicleType.PASSENGER]: 'Standard passenger cars, SUVs, minivans, and sedans designed for on-road use; identified by 4 wheels, enclosed cabin, and passenger seating configuration.',
    [VehicleType.MOTORCYCLE]: 'Two-wheeled motorized vehicles with engines over 50cc capable of highway speeds; identified by handlebar steering, no pedals, and requiring motorcycle endorsement.',
    [VehicleType.TRUCK]: 'Pickup trucks and light-duty trucks designed for hauling cargo; identified by open cargo bed and typically higher ground clearance than passenger vehicles.',
    [VehicleType.COMMERCIAL]: 'Vehicles used primarily for business purposes including delivery vans, box trucks, and commercial fleet vehicles; identified by commercial use designation and often higher weight ratings.',
    [VehicleType.TRAILER]: 'Towed vehicles without self-propulsion used to transport cargo, boats, or other equipment; identified by hitch connection point and lack of engine.',
    [VehicleType.MOPED]: 'Small motorized bikes with engines 50cc or less and top speeds around 30 mph; identified by small engine size, often includes pedals, and automatic transmission.',
    [VehicleType.VESSEL]: 'Watercraft including boats, personal watercraft (jet skis), and marine vehicles; identified by hull design and marine propulsion systems.',
    [VehicleType.LOW_SPEED]: 'Street-legal Low-Speed Vehicles (LSVs) with max speed of 20-25 mph; MUST be street-legal with required DOT safety equipment: headlights, taillights, brake lights, turn signals, mirrors, horn, reflectors, seat belts, and DOT-approved windshield. Includes any vehicle (including golf carts) that is sold as street-legal or marketed as road-ready with full LSV safety compliance.',
    [VehicleType.MOTORSCOOTER]: 'Small motorized two-wheeled vehicles with step-through frame design; identified by platform floorboard, smaller wheels than motorcycles, and typically smaller engines.',
    [VehicleType.ATV]: 'All-Terrain Vehicles (four-wheelers/quads) designed exclusively for off-road use; identified by 4 wheels, handlebar steering, straddle seating, and knobby tires (not street legal).',
    [VehicleType.ORV]: 'Off-Road Vehicles including side-by-sides and UTVs designed for off-highway recreational use; identified by side-by-side seating, roll cage, and off-road suspension (not street legal).',
    [VehicleType.NON_TITLED_VEHICLE]: 'Low-speed vehicles (under 20 mph) that are NOT street-legal due to lacking required DOT safety equipment; intended for private property, gated communities, or designated paths only. Includes standard e-bikes, go-karts, bicycles, golf carts, and neighborhood vehicles without headlights, taillights, turn signals, mirrors, horn, seat belts, or DOT-approved windshield. Not titled or registered for road use.',
    [VehicleType.DUAL_SPORT]: 'Motorcycles designed for both on-road and off-road use with street-legal equipment; identified by dual-purpose tires, higher ground clearance than standard motorcycles, and both DOT-approved lights and off-road capability.',
    [VehicleType.OHV]: 'Off-Highway Vehicles designed for off-road use only, NOT street-legal, with speeds exceeding 20 mph. Includes dirt bikes, trail bikes, and high-speed recreational vehicles (including modified or performance golf carts over 20 mph). Identified by off-road tires, minimal/no street-legal equipment, and recreational or utility off-highway purpose.',
};
var VehicleCategory;
(function (VehicleCategory) {
    VehicleCategory["SXS"] = "Side-by-Side";
    VehicleCategory["ATV"] = "ATV";
    VehicleCategory["DUAL_SPORT"] = "Dual Sport";
    VehicleCategory["MOTORCYCLE"] = "Motorcycle";
    VehicleCategory["OFF_ROAD_MOTORCYCLE"] = "Off-Road Motorcycle";
    VehicleCategory["SCOOTER"] = "Scooter";
    VehicleCategory["E_BIKE"] = "E-Bike";
    VehicleCategory["GOLFCART"] = "Golf Cart";
    VehicleCategory["SNOWMOBILE"] = "Snowmobile";
    VehicleCategory["PWC"] = "Personal Watercraft";
    VehicleCategory["BOAT"] = "Boat";
    VehicleCategory["UTV"] = "UTV";
    VehicleCategory["MOPED"] = "Moped";
    VehicleCategory["TRIKE"] = "Trike";
    VehicleCategory["TRAILER"] = "Trailer";
    VehicleCategory["CAR"] = "Car";
    VehicleCategory["TRUCK"] = "Truck";
    VehicleCategory["OTHER"] = "Other";
})(VehicleCategory || (VehicleCategory = {}));
const InventoryVehicleTypeMapping = {
    [VehicleCategory.SXS]: VehicleType.ORV,
    [VehicleCategory.UTV]: VehicleType.ORV,
    [VehicleCategory.ATV]: VehicleType.ATV,
    [VehicleCategory.DUAL_SPORT]: VehicleType.DUAL_SPORT,
    [VehicleCategory.MOTORCYCLE]: VehicleType.MOTORCYCLE,
    [VehicleCategory.OFF_ROAD_MOTORCYCLE]: VehicleType.ORV,
    [VehicleCategory.SCOOTER]: VehicleType.MOTORSCOOTER,
    [VehicleCategory.MOPED]: VehicleType.MOPED,
    [VehicleCategory.E_BIKE]: VehicleType.NON_TITLED_VEHICLE,
    [VehicleCategory.GOLFCART]: VehicleType.NON_TITLED_VEHICLE,
    [VehicleCategory.SNOWMOBILE]: VehicleType.OHV,
    [VehicleCategory.PWC]: VehicleType.VESSEL,
    [VehicleCategory.BOAT]: VehicleType.VESSEL,
    [VehicleCategory.TRIKE]: VehicleType.MOTORCYCLE,
    [VehicleCategory.TRAILER]: VehicleType.TRAILER,
    [VehicleCategory.CAR]: VehicleType.PASSENGER,
    [VehicleCategory.TRUCK]: VehicleType.TRUCK,
    [VehicleCategory.OTHER]: VehicleType.COMMERCIAL,
};
/**
 * Vehicle categories not supported for online sales on the Ekho platform.
 * Used to gate both inventory matching and canon vehicle building.
 */
const UNSUPPORTED_ONLINE_SALE_CATEGORIES = [
    VehicleCategory.BOAT,
    VehicleCategory.PWC,
    VehicleCategory.SNOWMOBILE,
    VehicleCategory.TRAILER,
    VehicleCategory.CAR,
    VehicleCategory.TRUCK,
    VehicleCategory.OTHER,
];
const BODY_TYPE_TO_VEHICLE_CATEGORY = {
    // Cars
    Cabriolet: VehicleCategory.CAR,
    Convertible: VehicleCategory.CAR,
    Coupe2D: VehicleCategory.CAR,
    Hatchback3D: VehicleCategory.CAR,
    Limousine: VehicleCategory.CAR,
    Sedan4D: VehicleCategory.CAR,
    StationWagon5D: VehicleCategory.CAR,
    TwoDoor: VehicleCategory.CAR,
    FourDoor: VehicleCategory.CAR,
    PassengerVan: VehicleCategory.CAR,
    // Trucks
    Pickup: VehicleCategory.TRUCK,
    Truck: VehicleCategory.TRUCK,
    TruckTractor: VehicleCategory.TRUCK,
    TruckVan: VehicleCategory.TRUCK,
    // Other
    Ambulance: VehicleCategory.OTHER,
    Bus: VehicleCategory.OTHER,
    ManufacturedHome: VehicleCategory.OTHER,
    MotorHome: VehicleCategory.OTHER,
    SpecialMobileMachinery: VehicleCategory.OTHER,
    Tractor: VehicleCategory.OTHER,
    // Motorcycles
    Motorcycle: VehicleCategory.MOTORCYCLE,
    Roadster: VehicleCategory.MOTORCYCLE,
    OffRoadMotorcycle: VehicleCategory.OFF_ROAD_MOTORCYCLE,
    DualSport: VehicleCategory.DUAL_SPORT,
    Trike: VehicleCategory.TRIKE,
    // Powersports
    ATV: VehicleCategory.ATV,
    SideBySide: VehicleCategory.SXS,
    UTV: VehicleCategory.UTV,
    UtilityPassengerSUV: VehicleCategory.UTV,
    UtilityTruck: VehicleCategory.UTV,
    Scooter: VehicleCategory.SCOOTER,
    Moped: VehicleCategory.MOPED,
    Snowmobile: VehicleCategory.SNOWMOBILE,
    // Light electric / micro-mobility
    'E-Bike': VehicleCategory.E_BIKE,
    Gokart: VehicleCategory.GOLFCART,
    GolfCart: VehicleCategory.GOLFCART,
    // Boats / watercraft
    PontoonBoat: VehicleCategory.BOAT,
    FishingBoat: VehicleCategory.BOAT,
    Bowrider: VehicleCategory.BOAT,
    CenterConsole: VehicleCategory.BOAT,
    DeckBoat: VehicleCategory.BOAT,
    CabinCruiser: VehicleCategory.BOAT,
    Sailboat: VehicleCategory.BOAT,
    BoatOther: VehicleCategory.BOAT,
    Jetski: VehicleCategory.PWC,
    PersonalWatercraft: VehicleCategory.PWC,
    // Trailers
    Trailer: VehicleCategory.TRAILER,
    MultipurposeTrailer: VehicleCategory.TRAILER,
    TrailerUtility: VehicleCategory.TRAILER,
    CamperTrailer: VehicleCategory.TRAILER,
    TrailerCoach: VehicleCategory.TRAILER,
};
function deriveVehicleCategoryFromBodyType(bodyType) {
    if (bodyType in BODY_TYPE_TO_VEHICLE_CATEGORY) {
        return BODY_TYPE_TO_VEHICLE_CATEGORY[bodyType];
    }
    return null;
}
var UseType;
(function (UseType) {
    UseType["PERSONAL"] = "Personal";
    UseType["COMMERCIAL"] = "Commercial";
})(UseType || (UseType = {}));

export { InventoryVehicleTypeMapping, UNSUPPORTED_ONLINE_SALE_CATEGORIES, UseType, VehicleCategory, VehicleType, VehicleTypeDescriptions, deriveVehicleCategoryFromBodyType };
//# sourceMappingURL=VehicleTypes.js.map
